"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = exports.LabelCoordinates = exports.Dragging = exports.Zoom = void 0;
class Zoom {
    constructor(zoomIn, zoomOut, xChange, yChange, min) {
        this.zoomIn = zoomIn;
        this.zoomOut = zoomOut;
        this.xChange = xChange;
        this.yChange = yChange;
        this.min = min;
    }
}
exports.Zoom = Zoom;
class Dragging {
    constructor(active, xStart, yStart, xCurrent, yCurrent) {
        this.active = active;
        this.xStart = xStart;
        this.yStart = yStart;
        this.xCurrent = xCurrent;
        this.yCurrent = yCurrent;
    }
}
exports.Dragging = Dragging;
class LabelCoordinates {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
}
exports.LabelCoordinates = LabelCoordinates;
class Map {
    constructor(width, height, coordinates, scale, xCoordinate, yCoordinate, zoom, dragging, labelCoordinates) {
        this.width = width;
        this.height = height;
        this.coordinates = coordinates;
        this.scale = scale;
        this.xCoordinate = xCoordinate;
        this.yCoordinate = yCoordinate;
        this.zoom = zoom;
        this.dragging = dragging;
        this.labelCoordinates = labelCoordinates;
    }
}
exports.Map = Map;
